// extracted by mini-css-extract-plugin
export var box = "_7h-1";
export var checked = "_7h-2";
export var descriptionSpacer = "_7h-9";
export var disabled = "_7h-3";
export var icon = "_7h-6";
export var input = "_7h-0";
export var labelSpacer = "_7h-8";
export var medium = "_7h-5";
export var small = "_7h-4";
export var text = "_7h-7";